
  var _styles = {
  "deal-three": {
    "width": "100%",
    "display": "flex",
    "alignItems": "center"
  },
  "deal-three-card": {
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "flexWrap": "wrap"
  },
  "deal-double": {
    "width": "10rem",
    "display": "flex",
    "alignItems": "center"
  },
  "deal-double-card": {
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  },
  "deal-double-id": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.45333rem",
    "fontWeight": "400"
  },
  "deal-single": {
    "display": "flex",
    "alignItems": "center"
  },
  "deal-single-card": {
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  },
  "deal-horizontal": {
    "paddingLeft": "0.16rem"
  }
};



  module.exports = _styles;
  